import { SignIn, SignUp } from "@clerk/react";
import { Link } from "react-router-dom";
import { Footer, Logo, SiteLinks } from "@/components/Brand";
import { DISCLAIMER } from "@/lib/content";

export const AuthLayout = ({ children, testId }) => (
  <div className="min-h-screen flex flex-col bg-alabaster">
    <div className="flex-1 grid lg:grid-cols-2">
      <aside className="hidden lg:flex items-center justify-center bg-charcoal" data-testid="auth-brand-panel">
        <Logo variant="goldTagline" className="h-44 xl:h-52" testId="auth-panel-logo" />
      </aside>
      <section className="flex flex-col items-center justify-center px-4 py-10 sm:px-8" data-testid={testId}>
        <Logo variant="goldTagline" className="h-20 mb-8 lg:hidden" testId="auth-logo" />
        {children}
        {sessionStorage.getItem("ahu_idle_signout") && <p className="mt-4 max-w-[400px] text-center text-sm text-charcoal" data-testid="idle-signed-out-note">For your privacy, AHU signed you out after 5 minutes without activity.</p>}
        <p className="mt-8 max-w-[400px] text-center text-[13px] leading-relaxed text-ink-soft" data-testid="auth-disclaimer">{DISCLAIMER}</p>
        {testId !== "start-page" && <Link to="/start" className="mt-4 btn-quiet text-sm" data-testid="auth-journey-link">New to AHU? Create an account</Link>}
        <SiteLinks keys={["help", "terms"]} className="mt-6" />
      </section>
    </div>
    <Footer />
  </div>
);

export const SignInPage = () => (
  <AuthLayout testId="signin-page">
    <SignIn routing="path" path="/sign-in" signUpUrl="/start" withSignUp />
  </AuthLayout>
);

export const SignUpPage = () => (
  <AuthLayout testId="signup-page">
    <p className="mb-4 text-sm text-ink-soft text-center max-w-[400px]">AHU is for adults 18 and over.</p>
    <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
  </AuthLayout>
);
